import React, {
	useEffect, useState
}from "react"
import {
	Form, Select, Tooltip
}from "antd"
import {
	reResponsibleExecutPositionActions
}from "../ReResponsiblesExecutPosition/actions"
import {
	managementActions
}from "../../Management/store/actions"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	useDebounce
}from "use-lodash-debounce"
import {
	CustomSelect
}from '../../../components/CustomSelect'
import './style.css'
import i18n from "./localization"
import InfoIcon from "../../../../public/info.svg"
import { CustomInput } from "../../../components/CustomInput"

const SelectExecutPosition = (props) => {
	const { form } = props
	const [searchPosition, setSearchPosition] = useState(null)
	const [searchUnit, setSearchUnit] = useState(null)
	const [table, setTable] = useState([])
	const [tableUnits, setTableUnits] = useState([])
	const RespExecPos = useSelector((state) => state.reResponsibleExecutPositionReducer.currentItem)
	const OrgUnits = useSelector((state) => state.managementReducer.orgUnits)
	const dispatch = useDispatch()
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const inputPosition = useDebounce(searchPosition, 750)
	const inputUnit = useDebounce(searchUnit, 750)

	const getResponsibleExecutPositionByName = (params) => {
		dispatch(reResponsibleExecutPositionActions.getResponsibleExecutPositionByName(params))
	}

	const getReOrganizationUnitsByName = (params) => {
		dispatch(managementActions.getOrganizationUnits(params))
	}

	const pageSize = 20

	useEffect(() => {
		const items = RespExecPos?.items
		if (items){
			const temp = []
			items.forEach((value, index) => {
				if (value.dateEnd == "0001-01-01T00:00:00" || value.dateEnd == null){
					temp.push({
						id      : value.id,
						name    : value.name,
						nameBel : value.nameBel,
						rowKey  : index
					})
				}
			})
			setTable(temp)
		}
	}, [RespExecPos])

	useEffect(() => {
		const items = OrgUnits?.items
		if (items){
			const temp = []
			items.forEach((value, index) => {
				if (value.dateEnd == "0001-01-01T00:00:00" || value.dateEnd == null){
					temp.push({
						code		: value.code,
						id      : value.id,
						name    : value.name,
						nameBel : value.nameBel,
						rowKey  : index
					})
				}
			})
			setTableUnits(temp)
		}
	}, [OrgUnits])

	useEffect(() => {
		if (inputPosition?.trim()?.length > 2){
			getResponsibleExecutPositionByName({
				name     : inputPosition.trim(),
				page     : 1,
				pageSize : pageSize
			})
		}
		else
			setTable([])
	}, [inputPosition])

  	useEffect(() => {
		if (inputUnit?.trim()?.length >= 2){
			getReOrganizationUnitsByName({
				name     : inputUnit.trim(),
				page     : 1,
				pageSize : pageSize,
				isActual : true
			})
		}
		else
			setTableUnits([])
	}, [inputUnit])

	function handleChangePosition(val){
		const selectedPosition = table?.find((value) => {
			return isRu ? value.name == val : value.nameBel == val
		})
		form.setFieldsValue({
			ReResponsibleExecutPosition: selectedPosition
		})
	}

	function handleChangeUnit(val){
		const selectedUnit = tableUnits?.find((value) => {
			return `(${ value.code }) ${ isRu ? value.name : value.nameBel }` == val
		})
		form.setFieldsValue({
			ReOrgUnit: selectedUnit
		})
	}

	return (
		<>
			<Form.Item
				noStyle
				shouldUpdate
			>
				{ () => {
					return (
						<Form.Item
							className="position-register-by-admin"
							label={ i18n.selectItems[isRu][0] }
							name="ReResponsibleExecutPosition"
							rules={ [
								{ message  : i18n.isRequired[isRu],
									required : true }
							] }
						>
							<>
								<CustomSelect
									allowClear
									showSearch
									notFoundContent={ null }
									optionLabelProp="label"
									placeholder={ i18n.placeholderItems[isRu][0] }
									style={ {
										width: "100%"
									} }
									value={ isRu ? form.getFieldValue("ReResponsibleExecutPosition")?.name : form.getFieldValue("ReResponsibleExecutPosition")?.nameBel }
									onChange={ handleChangePosition }
									onSearch={ (value) => setSearchPosition(value) }
								>
									{ table.map((value) => {
										return (
											<Select.Option
												key={ value.id }
												style={ {
													width: "100%"
												} }
												title={ isRu ? value.name : value.nameBel }
												value={ isRu ? value.name : value.nameBel }
											>
												{ isRu ? value.name : value.nameBel }
											</Select.Option>
										)
									}) }
								</CustomSelect>
							</>
						</Form.Item>)
				} }
			</Form.Item>
			<Form.Item
				noStyle
				shouldUpdate
			>
				{ () => {
					return (
						<Form.Item
							label={ i18n.selectItems[isRu][1] }
							name="ReOrgUnit"
						>
							<>
								<CustomSelect
									allowClear
									showSearch
									notFoundContent={ null }
									optionLabelProp="label"
									placeholder={ i18n.placeholderItems[isRu][1] }
									style={ {
										width: "100%"
									} }
									value={ isRu ? form.getFieldValue("ReOrgUnit")?.name : form.getFieldValue("ReOrgUnit")?.nameBel }
									onChange={ handleChangeUnit }
									onSearch={ (value) => setSearchUnit(value) }
								>
									{ tableUnits.map((value) => {
										return (
											<Select.Option
												key={ value.id }
												style={ {
													width: "100%"
												} }
												title={ `(${ value.code }) ${ isRu ? value.name : value.nameBel }` }
												value={ `(${ value.code }) ${ isRu ? value.name : value.nameBel }` }
											>
												{ `(${ value.code }) ${ isRu ? value.name : value.nameBel }` }
											</Select.Option>
										)
									}) }
								</CustomSelect>
							</>
						</Form.Item>)
				} }
			</Form.Item>
			<Form.Item
				label={<div className="positionAtSigningLabel">
					<span>{i18n.positionAtSigning[isRu]}</span>
					<Tooltip title={i18n.positionAtSigningInfo[isRu]} className="positionAtSigningIcon" >
						<img src={InfoIcon} />
					</Tooltip>
				</div>}
				name="reOrgUserSignPosition"
				rules={[{
					whitespace: true,
					message: i18n.positionAtSigningError[isRu]
				}]}
			>
				<CustomInput
					placeholder={ i18n.positionAtSigningPlaceholder[isRu] }
					type="text"
				/>
			</Form.Item>
		</>
	)
}

export default SelectExecutPosition
